import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightMealInformationComponent } from './flight-meal-information.component';
import { StaticMsgModule } from '@lib/pipes';
import { FlightMealService } from '@common/services/my-booking/flight-meal-service/flight-meal-service';
import { FlightMealDetailModule } from '../flight-meal-detail/flight-meal-detail.module';

@NgModule({
  declarations: [FlightMealInformationComponent],
  imports: [CommonModule, StaticMsgModule, FlightMealDetailModule],
  providers: [FlightMealService],
  exports: [FlightMealInformationComponent],
})
export class FlightMealInformationModule {}
